import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import {
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
  ElderSelectComponent,
  ElderSinglePaneWrapperComponent,
  ElderToastService,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject, Subject } from 'rxjs'
import { FacilityContextService } from '../../context/facility-context/facility-context.service'
import { FacilitySelectDirective } from '../../facilities/facility-select.directive'
import { OptimisationDayBrowserComponent } from '../optimisation-day-browser/optimisation-day-browser.component'
import { OptimisationScheduleDetailComponent } from '../optimisation-schedule-detail/optimisation-schedule-detail.component'

@Component({
  selector: 'app-optimisation-schedule-settings',
  templateUrl: './optimisation-settings-schedule.component.html',
  styleUrls: ['./optimisation-settings-schedule.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    ElderSelectComponent,
    FacilitySelectDirective,
    MatButton,
    MatIcon,
    OptimisationScheduleDetailComponent,
    OptimisationDayBrowserComponent,
    AsyncPipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderSinglePaneWrapperComponent,
  ],
})
export class OptimisationSettingsScheduleComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  public readonly facilityId$ = new BehaviorSubject<string>(null)
  public readonly requestSave: Subject<Event> = new Subject<Event>()
  private facilityContextService = inject(FacilityContextService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.facilityContextService.facility$.subscribe({
      next: (facility) => {
        if (facility) {
          this.facilityId = facility.id
        }
      },
      error: (err) => this.toastService.error('messages.loading_failed', err),
    })
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set facilityId(facilityId: string) {
    this.facilityId$.next(facilityId)
  }

  public get facilityId(): string {
    return this.facilityId$.getValue()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onSave(event: Event): void {
    this.requestSave.next(event)
  }
}
